/**
 * @description Shuffle an array. Good for small arrays.
 * @param {T[]} array - The array to shuffle
 * @returns {T[]} The shuffled array
 */
export function shuffleArray<T>(array: T[]): T[] {
  return array.sort(() => Math.random() - 0.5)
}
